import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";
import { ValueTableConfiguration } from "../../../Rule/Table/Value/ValueTableConfiguration";
import { DataDefinition } from "../../../Common/Data/DataDefinition";

export class RunValueTable extends FlowStepData {
    readonly __type: string = "run_value_table";

    executable: ValueTableConfiguration = new ValueTableConfiguration();

    constructor() {
        super();

        this.executable.executionResult = new DataDefinition();
        this.name = "Run Value Table";
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return [new MultiExecutableOutputDefinition("done", this.executable.getExecutionResult().fields)];
    }
}
